// * ========================================================================
// * Modals
// *
// * Use this module if your element is present in markup, but hidden and you only need to toggle it visible/invisible
// * Add class `js-trigger-modal` and `data-target="ELEMENT_ID"` to element that opens the modal
// *
// * Add class `js-modal` to modal element
// *
// * Since modal is fullscreen, you need to have an element that closes the modal
// * Add class `js-close-modal` to element that closes the modal
// *
// * ========================================================================

//import $ from 'jquery';
import A11yDialog from 'a11y-dialog';

const modals = (() => {
  const body = document.querySelector('body');

  function init() {
    const modals = document.querySelectorAll('.js-modal');

    modals.forEach((modal) => {
      const dialog = new A11yDialog(modal);
      dialog.on('show', onOpen);
      dialog.on('hide', onClose);
    });

    window.addEventListener('popstate', (event) => {
      if(!event.state) {
        close();
      }
    });
  }

  /**
   * Modal opening actions
   * @param {HTMLElement} modal modal element
   * @param {Event} event modal opening event
   */
  function onOpen(modal, event) {
    history.pushState(null, null, '');

    const triggerBtn = event.currentTarget;
    const dynamicContentHolder = triggerBtn.dataset.dialogContentHolder ? document.getElementById(triggerBtn.dataset.dialogContentHolder) : false;
    if(dynamicContentHolder) {
      updateModalContent(modal, dynamicContentHolder.innerHTML);
    }

    // Wait till call stack clears
    setTimeout(() => {
      modal.classList.add('is-shown');
    }, 0);

    body.classList.add('has-modal-active');
  }

  /**
   * Modal closing actions
   * @param {HTMLElement} modal modal element
   * @param {Event} event modal opening event
   */
  function onClose(modal, event) {
    modal.classList.remove('is-shown');
    body.classList.remove('has-modal-active');
  }

  /**
   * Change modal content
   * @param {HTMLElement} modal modal element
   * @param {string} content new content
   */
  function updateModalContent(modal, content) {
    const modalContentArea = modal.querySelector('.modal__content');
    if(content && modalContentArea) {
      modalContentArea.innerHTML = content;
    }
  }

  /**
   * Close modal by triggering its close button
   */
  function close() {
    const activeCloseBtn = document.querySelector('.modal.is-shown .js-modal__close');
    if(activeCloseBtn) {
      activeCloseBtn.click();
    }
  }

  return {
    init,
    close
  };

})();

export default modals;
export { modals };
